// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ca0102ac","239":"3128fd51","453":"f509feba","667":"479f4ca1"}[chunkId] + ".chunk.js";
};